import type {
  Configuration,
  RestoreEntraIdWithMicrosoft365Request,
  RestoreJobInitiationResponse,
} from '@repo/api-gw-sdk';
import { SnapshotsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/unified-identity-restore';

export const unifiedIdentityRestore = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const snapshotsApi = new SnapshotsApi(config);

  return {
    /**
     * Resolves what the backups can say about each selected entity — its
     * inferred directory presence, and which Microsoft 365 snapshots hold which
     * of the selected users — in one call. Restore accounts are not part of the
     * response; they come from the shared restore-accounts API. Pass a null
     * `resourceId` to hold the request.
     */
    usePlan: (
      resourceId: string | null,
      snapshotId: string | undefined,
      entityIds: string[]
    ) =>
      httpClient.execute(
        snapshotsApi.getUnifiedIdentityRestorePlan.bind(snapshotsApi),
        resourceId && snapshotId && entityIds.length > 0 ? baseUrl : null,
        `/plan/${resourceId}/${snapshotId}`,
        currentProjectId,
        resourceId ?? '',
        snapshotId ?? '',
        entityIds.join(',')
      ),

    restore: (
      resourceId: string,
      snapshotId: string,
      payload: RestoreEntraIdWithMicrosoft365Request
    ): Promise<RestoreJobInitiationResponse> =>
      snapshotsApi.restoreEntraIdWithMicrosoft365(
        currentProjectId,
        resourceId,
        snapshotId,
        payload
      ),
  };
};
